<template>
  <div class="col-lg-12">
    <label>{{ label }}</label>
    <div class="row">
      <TextBoxWithLabel
        classList="col-lg-4"
        label="From $"
        :type="TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER"
        v-model="rangeMin"
        :submitClicked="submitClicked"
        @input="handleDataChange()"
      />
      <TextBoxWithLabel
        classList="col-lg-4"
        label="To $"
        :type="TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER"
        v-model="rangeMax"
        :submitClicked="submitClicked"
        @input="handleDataChange()"
      />
      <RadioGroup
        classList="col-lg-4"
        label="Per"
        name="per"
        :optionList="$store.getters.salaryOptionList"
        v-model="salaryOption"
        :submitClicked="submitClicked"
        @input="handleDataChange()"
      />
    </div>
  </div>
</template>
<script>
/* This component is used to select working hours (from ... to ...) for each working day (From Monday to Friday)*/
import { TEXTBOX_INPUT_TYPE } from "../../constants/custom-define-type";
import TextBoxWithLabel from "./TextBoxWithLabel";
import RadioGroup from "./RadioGroup";

export default {
  name: "SalaryRange",
  components: {
    TextBoxWithLabel,
    RadioGroup
  },
  props: {
    // Label at the top of component
    label: String,
    // Input value, which is used for v-model
    value: Array,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let rangeMin = "";
    let rangeMax = "";
    let salaryOption = "";
    if (this.value != null && this.value.length >= 3) {
      rangeMin = this.value[0];
      rangeMax = this.value[1];
      salaryOption = this.value[2];
    }
    return {
      rangeMin: rangeMin,
      rangeMax: rangeMax,
      salaryOption: salaryOption,
      TEXTBOX_INPUT_TYPE: TEXTBOX_INPUT_TYPE
    };
  },
  methods: {
    handleDataChange() {
      this.$emit("input", [this.rangeMin, this.rangeMax, this.salaryOption]);
    }
  }
};
</script>

<style scoped>
.day-checkbox-container {
  display: flex;
  align-items: center;
}

.day-checkbox-container .form-check-input {
  margin-top: 0;
}

.workday-label {
  margin-bottom: 0.5em;
}

@media only screen and (min-width: 768px) {
  .time-from-container,
  .time-to-container {
    padding-left: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SalaryRange.vue